angular.module('impactx.electronicdownload').controller('ElectronicDownloadCtrl', [
    '$scope',
    'selectedListItems',
    'dataGen',
    'NewWindowService',
    'ToastService',
    'ListHelperService',
    'ConfirmationService',
    'TranslationService',
    ElectronicDownloadController]);

function ElectronicDownloadController($scope, selectedListItems, dataGen, NewWindowService, ToastService, ListHelperService, ConfirmationService, TranslationService) {
    var self = this;

    self.downloadArticle = function (event, trns) {
        if (selectedListItems.getFirstSelectedItem().availableNumberOfDownloads > 0) {
            var newWindow = NewWindowService.openNewWindow("");

            dataGen.getData({}, {eddId: selectedListItems.getFirstSelectedId()}, "/electronicdownload/download").then(function (result) {
                var link = impactX.isDefined(result, 'data.link');
                if (link) {
                    newWindow.location = link;
                    refreshList();
                }
                else {
                    ToastService.openStandardToast(trns.contingentExhausted);
                }
            });
        }
        else {
            ToastService.openStandardToast(trns.contingentExhausted);
        }
    };

    self.deleteDownloadArticle = function (event, trns) {
        ConfirmationService.showConfirmationDialog(deleteDownloadRequest, event, trns.delete + '?', trns.delete, trns.abort, trns.deleteQuestion);
    };

    self.buttonDefinition = [{
        label: "download",
        action: self.downloadArticle,
        condition: selectedListItems.isSingleSelection,
        process: 'ElectronicDownload'
    }, {
        label: "delete",
        action: self.deleteDownloadArticle,
        condition: selectedListItems.isSingleSelection,
        process: 'ElectronicDownload'
    }];

    self.meta = {
        rowTemplate: 'modules/electronicdownload/templates/electronicdownload-list.row.tmpl.html',
        isSelectAble: true,
        ctrl: self,
        endpoint: '/electronicdownload/list',
        id: "electronicdownload",
        buttonDefinition: self.buttonDefinition
    };

    self.getMeta = function () {
        return self.meta;
    };

    function refreshList() {
        ListHelperService.refreshListData($scope, 'electronicDownloadCtrl', {unselectRow: selectedListItems.getFirstSelectedItem()});
    }

    function deleteDownloadRequest() {
        dataGen.postAsForm({}, {eddId: selectedListItems.getFirstSelectedId()}, "/electronicdownload/delete").then(function () {
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
            refreshList();
        });
    }
}